/**
 * Macedonian — the panel's default language. Wording follows docs/i18n/glossary-mk.md: formal
 * вие, short imperative on buttons („Испрати“, „Вклучи“), sentence case, „ден.“, „провизија“ for
 * merchant fees, „уплата“ for money a merchant receives, „кликнете“ (web). en.ts has exactly the
 * same keys (src/i18n/i18n.test.ts). Placeholders: {name}.
 */
export const mk = {
  'app.panelName': 'Веб-панел за трговци',
  'app.skipToContent': 'Прескокни до содржината',
  'app.loading': 'Се вчитува…',
  'app.retry': 'Повтори',
  'app.close': 'Затвори',
  'app.cancel': 'Откажи',
  'app.language': 'Јазик',
  'app.logout': 'Одјави се',
  'app.loadMore': 'Прикажи повеќе',
  'app.updated': 'Ажурирано во {time}',
  'app.notFound': 'Страницата не е пронајдена.',
  'app.toOverview': 'Кон прегледот',

  'nav.label': 'Главно мени',
  'nav.overview': 'Преглед',
  'nav.payments': 'Уплати',
  'nav.reconciliation': 'Усогласување',
  'nav.invoice': 'Фактура',
  'nav.counterQr': 'QR-код на касата',
  'nav.plan': 'Пакет',
  'nav.locked': 'Дел од веб-панелот',

  'live.connecting': 'Се поврзува…',
  'live.open': 'Во живо',
  'live.reconnecting': 'Повторно поврзување…',
  'live.stopped': 'Не е во живо',

  'login.title': 'Најава',
  'login.subtitle': 'Најавете се со телефонскиот број на вашиот бизнис-профил во ZINQ.',
  'login.phone': 'Телефонски број',
  'login.phoneHint': 'на пр. 071 222 222',
  'login.phoneInvalid': 'Внесете македонски мобилен број, на пр. 071 222 222.',
  'login.sendCode': 'Испрати код',
  'login.code': 'Код за потврда',
  'login.codeSentTo': 'Внесете го 6-цифрениот код за {phone}.',
  'login.codeInvalid': 'Кодот има 6 цифри.',
  'login.signIn': 'Најави се',
  'login.changePhone': 'Промени број',
  'login.resend': 'Испрати нов код',
  'login.devCode': 'Код за развој: {code}',
  'login.pilotCode': 'Тест-код за пилотот: {code}',
  'login.pilotFill': 'Внеси го',
  'login.pilotNumbersOnly': 'Користете го тестниот број од вашата картичка за учесник.',
  'login.wrongCode': 'Погрешен или истечен код. Обидете се повторно.',
  'login.tooMany': 'Премногу обиди. Почекајте малку и обидете се повторно.',
  'login.codeExpired': 'Кодот истече или е веќе искористен. Побарајте нов код.',
  'login.tooManyCodes': 'Премногу погрешни обиди. Побарајте нов код.',
  'login.noCustody': 'ZINQ не ги чува вашите пари — секоја уплата оди директно на вашата сметка во банката.',

  'noMerchant.title': 'Сѐ уште немате бизнис-профил',
  'noMerchant.body':
    'Најпрво поставете примање уплати во апликацијата ZINQ: отворете бизнис-профил и изберете сметка за примање. Потоа кликнете „Провери повторно“.',
  'noMerchant.retry': 'Провери повторно',

  'error.generic': 'Нешто не е во ред. Обидете се повторно.',
  'error.network': 'Нема врска со ZINQ. Проверете ја интернет-врската и обидете се повторно.',
  'error.session': 'Сесијата истече. Најавете се повторно.',
  'error.dateInvalid': 'Изберете валиден период.',
  'error.rangeOrder': 'Почетниот датум не може да биде по крајниот.',
  'error.rangeTooLong': 'Периодот може да биде најмногу {days} дена.',
  'error.rangeTooLongGeneric': 'Периодот е предолг. Изберете пократок период.',
  'error.tooMany': 'Премногу обиди. Почекајте малку и обидете се повторно.',
  'error.future': 'Изберете период што не е во иднина.',

  'upsell.title': 'Дел од веб-панелот',
  'upsell.history': 'Уплатите и прометот постари од 7 дена се дел од веб-панелот за трговци.',
  'upsell.export': 'Извозот во CSV е дел од веб-панелот за трговци.',
  'upsell.reconciliation':
    'Усогласувањето со изводите од банката е дел од веб-панелот за трговци.',
  'upsell.price': 'Веб-панел — {price} месечно, на месечната фактура од ZINQ.',
  'upsell.cta': 'Вклучи веб-панел',

  'period.label': 'Период',
  'period.today': 'Денес',
  'period.yesterday': 'Вчера',
  'period.week': 'Последни 7 дена',
  'period.month': 'Овој месец',
  'period.lastMonth': 'Претходен месец',
  'period.from': 'Од',
  'period.to': 'До',
  'period.show': 'Прикажи',

  'overview.title': 'Преглед',
  'overview.count': 'Уплати',
  'overview.gross': 'Бруто промет',
  'overview.fee': 'Провизија на ZINQ',
  'overview.net': 'Нето по провизија',
  'overview.settledOnly': 'Збировите ги вклучуваат само извршените уплати.',
  'overview.feeNote':
    'Провизијата од 0,9% (најмалку 3 ден.) се наплатува месечно на фактурата од ZINQ — не се одзема од уплатите.',
  'overview.latest': 'Последни уплати',
  'overview.empty': 'Сѐ уште нема уплати во овој период.',
  'overview.seeAll': 'Сите уплати',
  'overview.paying': '{payer} плаќа {amount} — се чека одобрување во банката',
  'overview.payingAnon': 'Купувач плаќа {amount} — се чека одобрување во банката',
  'overview.newPayment': 'Нова уплата: {amount} од {payer}',

  'payments.title': 'Уплати',
  'payments.export': 'Извези CSV',
  'payments.exporting': 'Се извезува…',
  'payments.exported': 'Датотеката {file} е преземена.',
  'payments.caption': 'Уплати од {from} до {to}',
  'payments.empty': 'Нема уплати во избраниот период.',
  'payments.totals': 'Извршени: {count} · бруто {gross} · провизија {fee} · нето {net}',
  'payments.col.date': 'Датум и време',
  'payments.col.status': 'Статус',
  'payments.col.reference': 'Код за плаќање',
  'payments.col.payer': 'Купувач',
  'payments.col.kind': 'QR-код',
  'payments.col.amount': 'Износ',
  'payments.col.fee': 'Провизија',
  'payments.col.net': 'Нето',
  'payments.kind.STATIC': 'На касата',
  'payments.kind.DYNAMIC': 'За наплата',

  'state.CREATED': 'Чека одобрување',
  'state.AWAITING_AUTHORIZATION': 'Чека одобрување',
  'state.AUTHORIZED': 'Се обработува',
  'state.SUBMITTED': 'Се обработува',
  'state.SETTLED': 'Извршено',
  'state.REJECTED': 'Одбиено',
  'state.FAILED': 'Неуспешно',
  'state.EXPIRED': 'Истечено',
  'state.CANCELLED': 'Откажано',

  'recon.title': 'Усогласување',
  'recon.subtitle': 'Уплатите преку ZINQ споредени со изводот од вашата банка.',
  'recon.account': 'Сметка за примање: {bank} · {number}',
  'recon.rangeNote': 'Периодот може да биде најмногу 31 ден.',
  'recon.card.settled': 'Платено преку ZINQ',
  'recon.card.matched': 'Усогласено',
  'recon.card.pending': 'Во тек',
  'recon.card.missing': 'Ги нема во изводот',
  'recon.card.mismatch': 'Различен износ',
  'recon.card.other': 'Други уплати',
  'recon.count.one': '{count} уплата',
  'recon.count.other': '{count} уплати',
  'recon.status.MATCHED': 'Усогласено',
  'recon.status.PENDING': 'Во тек',
  'recon.status.MISSING_IN_BANK': 'Го нема во изводот',
  'recon.status.AMOUNT_MISMATCH': 'Различен износ',
  'recon.status.OTHER_INCOMING': 'Друга уплата',
  'recon.explain.MATCHED': 'Уплатата е во изводот од банката, со истиот износ.',
  'recon.explain.PENDING':
    'Купувачот сѐ уште ја одобрува уплатата или банката ја обработува. Проверете повторно за неколку минути.',
  'recon.explain.MISSING_IN_BANK':
    'Банката го потврди плаќањето во ZINQ, но уплатата сѐ уште ја нема во изводот. Ако не се појави до следниот работен ден, јавете се во банката.',
  'recon.explain.AMOUNT_MISMATCH':
    'Во изводот е запишан друг износ од оној во ZINQ. Проверете ја уплатата со банката.',
  'recon.explain.OTHER_INCOMING':
    'Уплата на вашата сметка што не е направена преку ZINQ, на пр. трансфер од купувач или партнер.',
  'recon.explain.linkedOther':
    'Уплата со ознаката на ова плаќање преку ZINQ што не е усогласена со него (на пр. книжена двапати или по неуспешно плаќање). Проверете ја со банката.',
  'recon.filter.all': 'Сите',
  'recon.filterLabel': 'Прикажи статус',
  'recon.legend': 'Што значат статусите',
  'recon.caption': 'Усогласување од {from} до {to}',
  'recon.empty': 'Нема уплати во избраниот период.',
  'recon.col.status': 'Статус',
  'recon.col.zinqTime': 'Платено во ZINQ',
  'recon.col.bankDate': 'Книжено во банката',
  'recon.col.who': 'Купувач / уплаќач',
  'recon.col.reference': 'Реф.',
  'recon.col.zinqAmount': 'Износ во ZINQ',
  'recon.col.bankAmount': 'Износ во изводот',
  'recon.col.net': 'Нето',
  'recon.unavailable.title': 'Усогласувањето не е достапно',
  'recon.unavailable.MOCK_RAILS':
    'ZINQ работи во демо-режим без вистинска банка, па нема извод за споредба.',
  'recon.unavailable.NO_CONSENT':
    'Согласноста за читање на сметката за примање е истечена или повлечена. Поврзете ја банката повторно во апликацијата ZINQ.',
  'recon.unavailable.BANK_ERROR':
    'Банката моментално не одговара. Обидете се повторно за неколку минути.',

  'invoice.title': 'Фактура',
  'invoice.month': 'Месец',
  'invoice.heading': 'Месечна фактура за {month}',
  'invoice.status.OPEN': 'Отворена',
  'invoice.status.CLOSED': 'Затворена',
  'invoice.openNote': 'Месецот сѐ уште трае: фактурата се дополнува до крајот на месецот.',
  'invoice.kind.P2P_FEE': 'Надомест за трансфери во друга банка',
  'invoice.kind.PLUS_SUB': 'ZINQ Plus',
  'invoice.kind.MERCHANT_MDR': 'Провизија за QR-плаќања (0,9%, најмалку 3 ден.)',
  'invoice.kind.PANEL_SUB': 'Веб-панел за трговци',
  'invoice.col.item': 'Ставка',
  'invoice.col.count': 'Број',
  'invoice.col.amount': 'Износ',
  'invoice.col.date': 'Датум и време',
  'invoice.col.reference': 'Реф.',
  'invoice.total': 'Вкупно',
  'invoice.items': 'Поединечни ставки',
  'invoice.itemsLimit': 'Прикажани се најмногу 500 најнови ставки.',
  'invoice.empty': 'Нема ставки за овој месец.',
  'invoice.note':
    'ZINQ не ги чува вашите пари и не одзема ништо од уплатите: надоместите и провизиите се наплатуваат со оваа месечна фактура.',

  'qr.title': 'QR-код на касата',
  'qr.subtitle':
    'Испечатете го и ставете го на касата. Купувачот го скенира, го внесува износот и го одобрува плаќањето во својата банка.',
  'qr.cta': 'Скенирајте со ZINQ за да платите',
  'qr.merchantCode': 'Код на трговецот',
  'qr.reference': 'Код за плаќање',
  'qr.min': 'Најмал износ: {amount}',
  'qr.noCamera': 'Без камера? Внесете го кодот за плаќање во апликацијата ZINQ.',
  'qr.print': 'Печати (A6)',
  'qr.alt': 'QR-код за плаќање на {name}',
  'qr.never': 'Овој QR-код не се менува и не истекува.',
  'qr.noFee': 'Купувачот не плаќа надомест на ZINQ.',
  'qr.inactive':
    'Сметката за примање не е активна, па купувачите не можат да платат. Изберете друга сметка во апликацијата ZINQ.',

  'plan.title': 'Пакет',
  'plan.name': 'Веб-панел за трговци',
  'plan.price': '{price} месечно',
  'plan.billing': 'Се наплатува месечно, на фактурата од ZINQ.',
  'plan.status.active': 'Активен',
  'plan.status.inactive': 'Не е вклучен',
  'plan.activeSince': 'Активен од {date}.',
  'plan.cancelledOn': 'Откажан на {date}.',
  'plan.includes': 'Што вклучува',
  'plan.feature.reconciliation': 'Усогласување со изводите од банката',
  'plan.feature.export': 'Извоз на уплатите во CSV, за сметководство',
  'plan.feature.history': 'Уплати и промет постари од 7 дена',
  'plan.freeTitle': 'Бесплатно и без панелот',
  'plan.free.recent': 'Промет и уплати за денес и последните 7 дена',
  'plan.free.qr': 'QR-код на касата и QR-кодови за наплата',
  'plan.free.invoice': 'Месечна фактура',
  'plan.activate': 'Вклучи веб-панел',
  'plan.cancel': 'Откажи веб-панел',
  'plan.confirmActivate.title': 'Да се вклучи веб-панелот?',
  'plan.confirmActivate.body':
    '{price} за {month} ќе се додаде на вашата месечна фактура од ZINQ, а потоа секој месец додека не го откажете. Ако овој месец е веќе наплатен, нема повторно да се наплати.',
  'plan.confirmActivate.ok': 'Вклучи',
  'plan.confirmCancel.title': 'Да се откаже веб-панелот?',
  'plan.confirmCancel.body':
    'Усогласувањето, извозот и постарите уплати веднаш престануваат да бидат достапни. Веќе наплатениот месец не се враќа.',
  'plan.confirmCancel.ok': 'Откажи веб-панел',
  'plan.confirmCancel.keep': 'Задржи го панелот',
  'plan.activated': 'Веб-панелот е вклучен.',
  'plan.cancelled': 'Веб-панелот е откажан.',
  'plan.billedMonths': 'Наплатени месеци',
  'plan.noBilledMonths': 'Сѐ уште нема наплатени месеци.',

  'research.title': 'Истражување — резултати',
  'research.subtitle': 'Студија за валидација на ZINQ, 16.11–15.12.2026.',
  'research.key': 'Клуч за извоз',
  'research.keyHint': 'Клучот го добивате од тимот на ZINQ. Се чува само во ова јазиче.',
  'research.open': 'Отвори',
  'research.forget': 'Заборави го клучот',
  'research.keyInvalid': 'Погрешен клуч.',
  'research.study': 'Ознака на студијата',
  'research.studyHint': 'Стандардно: {label}. Пробните сесии на модераторите се под {label}-practice.',
  'research.from': 'Сесии од',
  'research.to': 'до',
  'research.refresh': 'Освежи',
  'research.sessions': 'Учесници',
  'research.role.USER': 'Корисници',
  'research.role.MERCHANT': 'Трговци',
  'research.hypotheses': 'Хипотези',
  'research.col.metric': 'Хипотеза',
  'research.col.value': 'Резултат',
  'research.col.n': 'Учесници (n)',
  'research.col.threshold': 'Праг',
  'research.col.outcome': 'Исход',
  'research.pass': 'Исполнето',
  'research.fail': 'Не е исполнето',
  'research.noData': 'Нема податоци',
  'research.tasks': 'Задачи',
  'research.col.task': 'Задача',
  'research.col.success': 'Успешност',
  'research.col.median': 'Медијана',
  'research.col.p90': '90. перцентил',
  'research.col.target': 'Цел',
  'research.sus': 'Употребливост (SUS)',
  'research.susNote': 'Просечен SUS-резултат (0–100) по улога.',
  'research.downloads': 'Извоз на податоци (CSV)',
  'research.downloadsNote':
    'Анонимизирани податоци: само шифра на учесникот, без имиња и телефонски броеви.',
  'research.export.sessions': 'Сесии',
  'research.export.tasks': 'Задачи',
  'research.export.answers': 'Одговори',
  'research.export.events': 'Настани',
  'research.downloaded': 'Датотеката {file} е преземена.',
} as const satisfies Record<string, string>;

export type MessageKey = keyof typeof mk;
